import { SET_POPUP, RESET_POPUP } from "../actions/popup";

const initialState = {
  popup: undefined
};

export default function popupReducer(state = initialState, action) {
  switch (action.type) {
    case SET_POPUP:
      return { ...state, popup: action.popup };
    case RESET_POPUP:
      return { ...state, popup: undefined };
    default:
      return state;
  }
}
